import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class CaseInsensitiveUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    // Only convert the path portion to lowercase, preserve query params and hash
    const [pathPart, ...rest] = url.split('?');
    const lowercasePath = pathPart.toLowerCase();
    const finalUrl = rest.length > 0 ? `${lowercasePath}?${rest.join('?')}` : lowercasePath;
    
    return super.parse(finalUrl);
  }
}
